import * as React from 'react';
import { useState, useRef, useCallback, useEffect } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { ShimmerEffect, Content, Container } from './ShimmingCard.styles.js';
import { useOverrides } from '../hooks/useOverrides/useOverrides.js';
import { ErrorScreen } from './ErrorScreen/ErrorScreen.js';

const defaultComponents = {
    Content: Content,
    Container: Container,
    ErrorScreen
};
const ShimmingCard = ({ className ="" , loading =false , children , defaultHoverBehavior =false , elevated =false , hasError =false , errorTitle , errorMessage , contactButtonText , onContactButtonClick , staticHeight =150 , overrides ={}  })=>{
    const [height, setHeight] = useState(null);
    const [opacity, setOpacity] = useState(1);
    const content = useRef(null);
    const container = useRef(null);
    const createContentRef = useCallback((element)=>{
        content.current = element;
        if (element) {
            const contentHeight = element.offsetHeight;
            setHeight(contentHeight);
        }
    }, []);
    const createContainerRef = useCallback((element)=>{
        container.current = element;
    }, []);
    const animateHeight = useCallback(()=>{
        if (!container.current || !content.current) {
            return;
        }
        const contentHeight = content.current.offsetHeight;
        const newContentHeight = loading ? staticHeight : contentHeight;
        setHeight(newContentHeight);
    }, [
        loading,
        staticHeight
    ]);
    useEffect(()=>{
        animateHeight();
        setOpacity(loading ? 0 : 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        loading
    ]);
    const { Container: { component: Container , props: containerProps  } , Content: { component: Content , props: contentProps  } , ErrorScreen: { component: ErrorScreen , props: errorScreenProps  }  } = useOverrides(defaultComponents, overrides);
    return /*#__PURE__*/ React.createElement(Container, {
        testId: "shimming-card",
        containerRef: createContainerRef,
        className: className,
        defaultHoverBehavior: defaultHoverBehavior,
        elevated: elevated,
        $loading: loading,
        $height: height,
        ...containerProps
    }, /*#__PURE__*/ React.createElement(Content, {
        ref: createContentRef,
        ...contentProps,
        opacity: opacity
    }, hasError ? /*#__PURE__*/ React.createElement(ErrorScreen, {
        title: errorTitle,
        message: errorMessage,
        contactButtonText: contactButtonText,
        onContactButtonClick: onContactButtonClick,
        ...errorScreenProps
    }) : children, /*#__PURE__*/ React.createElement(ReactResizeDetector, {
        handleHeight: !loading,
        handleWidth: false,
        onResize: animateHeight,
        refreshMode: "throttle",
        refreshRate: 100
    })), /*#__PURE__*/ React.createElement(ShimmerEffect, {
        active: loading
    }));
};
ShimmingCard.defaultComponents = defaultComponents;

export { ShimmingCard };
